import { CookieUtils } from '@/utils/cookie'
import { v4 as uuid } from 'uuid'

interface ActionLogConnectSessionId {
  connect_session_id: string
}
interface ListenLogConnectSessionId {
  connectSessionId: string
}
interface ConnectSessionId {
  keys: {
    CONNECT_SESSION_ID: 'connectSessionId'
  }
  getActionLogCsIdObject: () => ActionLogConnectSessionId
  getListenLogCsIdObject: () => ListenLogConnectSessionId
  setAppConnectSessionId: (csid: string) => void
  setSignInConnectSessionId: () => void
  signOutRemoveConnectSessionId: () => void
}

const connectSessionIdKeys = {
  CONNECT_SESSION_ID: 'connectSessionId',
} as const

const setConnectSessionId = (csid?: string) => {
  const csidValue = csid || uuid()
  const in30min = new Date(new Date().getTime() + 30 * 60 * 1000)
  CookieUtils.set(connectSessionIdKeys.CONNECT_SESSION_ID, csidValue, { expires: in30min })
  sessionStorage.setItem(connectSessionIdKeys.CONNECT_SESSION_ID, csidValue)
}

const getConnectSessionId = () => {
  const csIdInCookie = CookieUtils.get(connectSessionIdKeys.CONNECT_SESSION_ID)
  const csIdInsessionStorage = sessionStorage.getItem(connectSessionIdKeys.CONNECT_SESSION_ID)
  if (!csIdInCookie || !csIdInsessionStorage) {
    const csid = uuid()
    setConnectSessionId(csid)
    return csid
  }
  setConnectSessionId(csIdInCookie)
  return csIdInCookie
}

const getActionLogCsIdObject = (): ActionLogConnectSessionId => {
  return { connect_session_id: getConnectSessionId() }
}

const getListenLogCsIdObject = (): ListenLogConnectSessionId => {
  return { connectSessionId: getConnectSessionId() }
}

const setAppConnectSessionId = (csid: string) => setConnectSessionId(csid)

const setSignInConnectSessionId = () => setConnectSessionId()

const signOutRemoveConnectSessionId = () => {
  CookieUtils.delete(connectSessionIdKeys.CONNECT_SESSION_ID)
  sessionStorage.removeItem(connectSessionIdKeys.CONNECT_SESSION_ID)
}

export default <ConnectSessionId>{
  keys: connectSessionIdKeys,
  getActionLogCsIdObject,
  getListenLogCsIdObject,
  setAppConnectSessionId,
  setSignInConnectSessionId,
  signOutRemoveConnectSessionId,
}
